// extracted by mini-css-extract-plugin
module.exports = {"grid":"content-grid_grid__YGzzC","root":"content-grid_root__T4AtU"};